<!-- 采购计划跟踪 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="queryData"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>

    <div class="container">
      <div class="handle-wrapper">
        <eui-btn
          @click.native.prevent="exporPlanTrackLogSummary"
          type="primary"
          font-size="12px"
        >
          导出概要
        </eui-btn>
        <eui-btn
          @click.native.prevent="exportPlanTrackLogDetail"
          type="primary"
          font-size="12px"
        >
          导出明细
        </eui-btn>
      </div>

      <!-- table -->
      <e-table-list
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="true"
      >
        <template v-slot:code="tData">
          <eui-btn
            type="link"
            font-size="12px"
            @click="handleCodeDetail(tData.scope.row)"
          >
            {{ tData.scope.row.purchasePlanCode }}
          </eui-btn>
        </template>
        <template v-slot:progress="tData">
          <eui-btn
            type="link"
            font-size="12px"
            v-if="tData.scope.row.purchaseProgressDesc"
            @click="handleProgress(tData.scope.row)"
          >
            {{ tData.scope.row.purchaseProgressDesc }}
          </eui-btn>
          <span v-else>-</span>
        </template>
      </e-table-list>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          style="margin-top: 20px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :total="pageTotal"
          :page-size.sync="queryData.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>

    <!-- 采购进度 -->
    <track-dia
      :trackVisibleDia.sync="trackVisibleDia"
      :row="paramRow"
      type="purchasePlan"
    ></track-dia>
  </div>
</template>

<script>
import TrackDia from '../../demand/track/components/trackDia.vue';
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import utils from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/purchase';
export default {
  components: {
    eSearch,
    eTableList,
    TrackDia,
  },
  data() {
    return {
      trackVisibleDia: false,
      paramRow: {},
      tableData: [],
      pageTotal: 0,
      tableLabel: [
        {
          label: '物料分类',
          param: 'categoryName',
          align: 'center',
          minWidth: '150',
          fixed: 'left',
        },
        {
          label: '物料编码',
          param: 'categoryCustomCode',
          minWidth: '140',
          align: 'center',
          fixed: 'left',
          render: (row) => {
            return row.categoryCustomCode || '-';
          },
        },
        {
          label: '物料描述',
          param: 'categoryDesc',
          align: 'center',
          fixed: 'left',
          minWidth: '170',
        },
        {
          label: '采购数量',
          param: 'quantity',
          align: 'center',
          minWidth: '120',
        },
        {
          label: '已采数量',
          param: 'remainingQuantity',
          align: 'center',
          minWidth: '120',
        },
        {
          label: '采购计划',
          param: 'purchaseModeType',
          align: 'center',
          minWidth: '150',
          render: (row) => {
            let obj = {
              1: '选品下单',
              2: '询比价',
              3: '自行招标',
              4: '委托招标',
              5: '执行框架协议',
            };
            return obj[Number(row.purchaseModeType)];
          },
        },
        {
          label: '采购进度',
          align: 'center',
          minWidth: '170',
          slot: 'progress',
        },
        {
          label: '采购计划编号',
          align: 'center',
          slot: 'code',
          minWidth: '170',
        },
        {
          label: '采购计划名称',
          param: 'purchasePlanName',
          align: 'center',
          minWidth: '170',
        },
        {
          label: '审核状态',
          align: 'center',
          minWidth: '140',
          param: 'purchasePlanStatusDesc',
          // render: (row) => {
          //   let obj = {
          //     0: "新建",
          //     1: "待审核",
          //     2: "审核通过",
          //     3: "审核驳回",
          //   };
          //   return obj[Number(row.purchasePlanStatus)];
          // },
        },
        {
          label: '创建日期',
          param: 'createTime',
          align: 'center',
          minWidth: '170',
        },
        {
          label: '计划到货日期',
          param: 'expectedArrivalDate',
          align: 'center',
          fixed: 'right',
          minWidth: '170',
        },
      ],
      queryData: {
        purchasePlanName: '',
        purchasePlanCode: '',
        createTime: '',
        purchaseModeType: null,
        pageNum: 1,
        pageSize: 10,
      },
      fieldList: [
        {
          label: '采购计划名称',
          type: 'input',
          value: 'purchasePlanName',
        },
        {
          label: '采购计划编号',
          type: 'input',
          value: 'purchasePlanCode',
        },
        {
          label: '创建日期',
          type: 'date',
          value: 'createTime',
          defaultTime: ['00:00:00', '23:59:59'],
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          dateType: 'daterange',
        },
        {
          label: '状态',
          type: 'select',
          placeholder: '请选择',
          value: 'purchasePlanStatus',
          list: 'purchasePlanStatusList',
        },
      ],
      listTypeInfo: {
        purchasePlanStatusList: [
          { name: '新建', id: 0 },
          { name: '待审核', id: 1 },
          { name: '审核通过', id: 2 },
          { name: '驳回', id: 3 },
        ],
      },
    };
  },
  mounted() {
    this.purchasePlanTrack();
  },

  methods: {
    async exporPlanTrackLogSummary() {
      let res = await Api.exporPlanTrackLogSummary(this.queryData);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '采购计划概要');
      }
    },

    async exportPlanTrackLogDetail() {
      let res = await Api.exportPlanTrackLogDetail(this.queryData);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '采购计划详情');
      }
    },
    // 采购计划执行接口
    async purchasePlanTrack() {
      let params = { ...this.queryData };
      delete params.createTime;
      let res = await Api.purchasePlanTrack(params);
      if (res.code == '200') {
        this.tableData = res.data.records;
        this.pageTotal = res.data.total;
      }
    },

    // 查看采购计划详情
    handleCodeDetail(row) {
      this.$router.push({
        path: `/plan/purchaseQuery/purchaseDetail`,
        query: { ...row },
      });
    },
    // 进度
    handleProgress(row) {
      this.paramRow = row;
      console.log(row);
      this.trackVisibleDia = true;
    },

    // 查询
    handleFilter(val) {
      this.queryData = val;
      this.queryData.pageNum = 1;
      this.queryData.startTime = val.createTime ? val.createTime[0] : '';
      this.queryData.endTime = val.createTime ? val.createTime[1] : '';
      this.purchasePlanTrack();
    },
    // 重置
    handleReset(val) {
      this.queryData = this.$options.data().queryData;
      this.purchasePlanTrack();
    },
    // 分页
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.purchasePlanTrack();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.purchasePlanTrack();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  padding: 10px 20px 10px 36px;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.active-btn {
  background: #ccc;
}
.export-wrapper {
  margin-bottom: 20px;
  float: left;
}
.search-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .btn {
    width: 100px;
    text-align: center;
    height: 30px;
    line-height: 27px;
    cursor: pointer;
    font-size: 14px;
  }

  .reset-btn {
    background: #e8efff;
    border: 1px solid #2587ff;
    color: #2587ff;
    margin-right: 30px;
    line-height: 27px;
    &:hover,
    :active {
      background-color: #126edf;
      color: #fff;
    }
  }
  .submit-btn {
    background: #2587ff;
    border: 1px solid #2587ff;
    color: #ffffff;
    margin-right: 10px;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}
::v-deep .el-table {
  th.el-table__cell > .cell {
    font-weight: normal;
    font-size: 14px;
  }
}
.pagination-box {
  text-align: right;
}
</style>
